import Glide from '@glidejs/glide'

import '@glidejs/glide/dist/css/glide.core.min.css'
import '@glidejs/glide/dist/css/glide.theme.min.css'

import SlideStories from './carousel-stories'
import onVisible from './on-visible.js'

if (!document.querySelector('#carousel-linha')) {
  return
}

const glide = new Glide('#carousel-linha', {
  perView: 1,
})

let current_stories = ''

glide.on(['mount.after', 'run.after'], () => {
  const stories = document.querySelector(
    '#carousel-linha .glide__slide--active .carousel-stories'
  )
  // destroy previous stories
  if (current_stories) {
    current_stories.destroy()
  }
  // init new stories
  onVisible(stories, () => {
    current_stories = new SlideStories(stories.getAttribute('data-slide'))
  })
})
glide.mount()
